import { render, staticRenderFns } from "./ShareContent.vue?vue&type=template&id=0cf816eb&scoped=true&"
import script from "./ShareContent.vue?vue&type=script&lang=js&"
export * from "./ShareContent.vue?vue&type=script&lang=js&"
import style0 from "./ShareContent.vue?vue&type=style&index=0&id=0cf816eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf816eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
